import type { Dispatch, FunctionComponent, SetStateAction } from 'react'
import { useState } from 'react'
import styled, { css } from 'styled-components'
import { StyledH4 } from '../../../stylesNew'
import Chevron from '../../../assets/icons/catalog/chevron.svg'
import CookieOverview from './CookieOverview'
import CookieForm from './CookieForm'
import Modal from '../ModalElements/Modal'
import Paragraph from '../../Paragraph/Paragraph'
import Link, { Variant } from '../../Links/Link/Link'

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  @media screen and (min-width: 48rem) {
    flex-direction: row;
  }
`

export const StyledChevron = styled(Chevron)<{ degrees?: string }>`
  fill: currentColor;
  transform: rotate(90deg);
  height: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
  ${({ degrees }) =>
    degrees &&
    css`
      transform: rotate(${degrees});
    `}
`

const LinkContent = styled.span`
  display: flex;
  align-items: center;
`

const StyledLink = styled(Link)`
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

const LinkCollection = styled(Paragraph)`
  margin-bottom: 0;
  display: flex;
  flex-direction: column;

  a {
    margin-bottom: 0.5rem;
  }

  @media screen and (min-width: 48rem) {
    flex-direction: row;
    a {
      margin-bottom: 0;
    }
  }
`

interface FeedbackModalProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<FeedbackModalProps['open']>>
}

const CookieModalComponent: FunctionComponent<FeedbackModalProps> = ({ open, setOpen }) => {
  const [showOverview, setShowOverview] = useState(false)
  const onClose = () => {
    setOpen(false)
  }

  return (
    <Modal open={open} hideCloseButton>
      <>
        {!showOverview && (
          <>
            <StyledH4 id="dialog_label" forwardedAs="h4">
              Cookies op deze site
            </StyledH4>
            <Paragraph small style={{ marginTop: '1.5rem' }}>
              Om u op deze website zo goed mogelijk van dienst te kunnen zijn, maken wij gebruik van
              functionele en analytische cookies. Klikt u op akkoord, dan gaat u er akkoord mee dat
              er cookies worden geplaatst. U kunt u de toestemming later nog altijd wijzigen of
              intrekken.
            </Paragraph>
            <CookieForm closeModal={onClose} />
            <RowWrapper>
              <LinkCollection small>
                <StyledLink
                  href=""
                  onClick={(evt) => {
                    evt.preventDefault()
                    setShowOverview(true)
                  }}
                  style={{ marginRight: '1.5rem' }}
                  variant={Variant.Blue}
                >
                  <LinkContent>
                    <StyledChevron degrees="-90deg" />
                    Overzicht van cookies
                  </LinkContent>
                </StyledLink>
                <StyledLink
                  href="https://www.amsterdam.nl/privacy/"
                  target="_blank"
                  rel="noreferrer"
                  variant={Variant.Blue}
                >
                  <LinkContent>
                    <StyledChevron degrees="-90deg" />
                    Privacybeleid
                  </LinkContent>
                </StyledLink>
              </LinkCollection>
            </RowWrapper>
          </>
        )}
        {showOverview && <CookieOverview setShowOverview={setShowOverview} />}
      </>
    </Modal>
  )
}

export default CookieModalComponent
